<template>
  <v-row>
    <v-col cols="12">
      <div class="text-body">
        QR code shown on screen is for illustrative purposes only.
      </div>
    </v-col>
    <v-col cols="7">
      <v-col cols="12">
        <UploadImageDialog
          :show="showUploadImageDialog"
          isDisplayImage
          previewType="square"
          @close="showUploadImageDialog = false"
          @uploaded="handleUploaded"
          :applyImageCompression="true"
          :image="editImageURL"
          ref="uploadImageDialog"
          :isBadgeOrQrCode="true"
          :uploadToBusinessProfile="false"
        />
        <div class="d-flex flex-wrap justify-start align-center">
          <div class="mr-6">
            <AddNewImage
              @click="showUploadImageDialog = true"
              :size="140"
              text="Add new logo"
            />
          </div>

          <div v-for="(image, index) in imageList" :key="`qrCodeImage${index}`">
            <v-hover v-slot="{ hover }">
              <v-sheet
                :class="[
                  { selected: selectedImage == image },
                  'outlined-border d-flex justify-center align-center mr-6 my-6',
                ]"
                :outlined="selectedImage == image ? true : true"
                rounded="lg"
                width="140"
                height="140"
                @click="selectedImage = image"
              >
                <v-img
                  :src="image"
                  class="rounded-lg"
                  width="139"
                  height="139"
                  style="border-radius: 7px !important"
                >
                  <div
                    class="text-center mt-3"
                    v-show="
                      hover &&
                      !defaultImages.includes(image) &&
                      !(selectedImage == image)
                    "
                  >
                    <v-btn
                      :key="`edit${index}`"
                      fab
                      x-small
                      color="white"
                      class="mr-1"
                      @click.stop="handleEdit(image)"
                    >
                      <v-icon :class="{ 'show-btns': hover }" color="secondary">
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                    <v-btn
                      :key="`delete${index}`"
                      @click.stop="handleDelete(image)"
                      fab
                      x-small
                      color="white"
                    >
                      <v-icon :class="{ 'show-btns': hover }" color="secondary">
                        mdi-trash-can
                      </v-icon>
                    </v-btn>
                  </div>
                </v-img>
              </v-sheet>
            </v-hover>
          </div>
        </div>
      </v-col>
    </v-col>
    <!--Start: Fixed column-->
    <v-col cols="5">
      <div class="text-right">
        <v-btn
          width="150"
          color="primary"
          depressed
          large
          class="text-body-1"
          :disabled="isSaveDisabled"
          @click="handleSave"
          >Save</v-btn
        >
      </div>

      <div class="mt-10 pt-10">
        <QRCode
          link="pappyon.com"
          :logo="selectedImage"
          :showDownloadButton="false"
          :size="250"
        />
      </div>
    </v-col>

    <!--End: Fixed column-->
  </v-row>
</template>

<script>
import QRCode from "@/components/QRCode";
import AddNewImage from "@/components/AddNewImage";
import UploadImageDialog from "@/components/UploadImageDialog";
import { mapActions, mapGetters } from "vuex";
import {getFirestore, writeBatch} from "firebase/firestore";
import {businessCardsDocRef} from "@/shared/firebase_utils";

export default {
  components: {
    QRCode,
    AddNewImage,
    UploadImageDialog,
  },
  created() {
    this.selectedImage = this.businessProfile.qrCodeImageURL || "";
    this.imageList = this.getImageList();
  },
  data() {
    return {
      showUploadImageDialog: false,
      defaultImages: [
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_1.png?alt=media&token=eaaa4308-db9d-4b4d-9ad4-828ac7454ab7",
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_2.png?alt=media&token=e2112092-7b35-4a75-987f-dd542ce8b9e2",
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_3.png?alt=media&token=30456377-366c-4a8d-aaeb-2c3db9568210",
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_4.png?alt=media&token=c9111f1a-c150-4847-b2ef-2fb657d1beff",
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_5.png?alt=media&token=fd78d284-470e-4bd6-9b7e-cb7ebad926f0",
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_6.png?alt=media&token=2f55f010-cbec-4d89-9058-9f43a397a7bb",
      ],
      imageList: [],
      selectedImage: "",
      editImageURL: "",
    };
  },
  computed: {
    ...mapGetters(["businessProfile", "cardHolders"]),
    isSaveDisabled() {
      if (
        this.selectedImage == this.businessProfile.qrCodeImageURL ||
        this.selectedImage == ""
      )
        return true;
      return false;
    },
  },
  watch: {
    "businessProfile.badgeQRImageURLs": function () {
      this.imageList = this.getImageList();
    },
  },
  methods: {
    ...mapActions(["updateBusinessProfileDetails", "showSnackbar"]),

    getImageList() {
      let imageList = [];

      if (this.selectedImage) {
        //Push all default images to imageList except selectedImage
        imageList = this.defaultImages.filter((imageURL) => {
          return imageURL != this.selectedImage;
        });
        //Add selected image at index 0
        imageList.unshift(this.selectedImage);
      } else imageList = [...this.defaultImages];

      if (
        this.businessProfile.badgeQRImageURLs?.length != 0 &&
        this.businessProfile.badgeQRImageURLs != undefined
      ) {
        let insertAtIndex = imageList.indexOf(this.selectedImage) == -1 ? 0 : 1;
        //Insert images uploaded by user at second index onwards.
        imageList.splice(
          insertAtIndex,
          0,
          ...this.businessProfile.badgeQRImageURLs?.filter((imageURL) => {
            return imageURL != this.selectedImage;
          })
        );
      }

      return imageList;
    },
    async handleUploaded(downloadURL) {
      this.selectedImage = downloadURL;

      let badgeQRImageURLs = [];
      if (this.businessProfile.badgeQRImageURLs)
        badgeQRImageURLs = [
          downloadURL,
          ...this.businessProfile.badgeQRImageURLs,
        ];
      else badgeQRImageURLs.push(downloadURL);

      await this.updateBusinessProfileDetails({
        badgeQRImageURLs: badgeQRImageURLs,
      });
    },

    async handleSave() {
      await this.updateBusinessProfileDetails({
        qrCodeImageURL: this.selectedImage,
      });

      //update QR code logo in business card
      try {
        let db = getFirestore();
        let batch = writeBatch(db);

        this.cardHolders.forEach((cardHolder) => {
          let docRef = businessCardsDocRef(cardHolder.businessCardId);
          batch.update(docRef, { qrCodeImageURL: this.selectedImage });
        });
        this.showSnackbar({
          show: true,
          text: "QR code updated successfully!",
        });

        await batch.commit();
      } catch (error) {
        console.log(
          "Error occurred while updating card holders details: ",
          error
        );
        this.showSnackbar({
          show: true,
          text: "Error occurred, please try again!",
        });
      }
    },
    async handleEdit(image) {
      this.editImageURL = image;

      //Fetch the image from url, convert to blob
      let res = await fetch(image);
      let blob = await res.blob();
      this.$refs.uploadImageDialog.fileAdded(blob);
      this.showUploadImageDialog = true;
    },
    async handleDelete(imageURL) {
      try {
        this.businessProfile.badgeQRImageURLs =
          this.businessProfile.badgeQRImageURLs?.filter((image) => {
            return image != imageURL;
          });
        await this.updateBusinessProfileDetails({
          badgeQRImageURLs: this.businessProfile?.badgeQRImageURLs,
        });
        this.showSnackbar({ show: true, text: "Deleted successfully!" });
      } catch (err) {
        console.log("Error occurred while deleting an uploaded image: ", err);
        this.showSnackbar({
          show: true,
          text: "Could not delete image, please try again!",
        });
      }
    },
  },
};
</script>

<style></style>
